const isDev = import.meta.env.DEV;
const DEV_API_URL = "http://localhost:3001";
const DEV_WS_URL = "ws://localhost:3001";
const PROD_API_URL = "https://api.evyely.com";
const PROD_WS_URL = "wss://api.evyely.com";
function cleanUrl(value, fallback = "") {
    return (value?.trim() || fallback).replace(/\/$/, "");
}
function isLocalUrl(value) {
    try {
        const { hostname } = new URL(value);
        return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
    }
    catch {
        return false;
    }
}
function resolveUrl(envValue, devFallback, productionFallback) {
    const value = cleanUrl(envValue);
    if (isDev)
        return cleanUrl(value, devFallback);
    if (value && !isLocalUrl(value))
        return value;
    return productionFallback;
}
export const API_URL = resolveUrl(import.meta.env.VITE_API_URL, DEV_API_URL, PROD_API_URL);
export const WS_URL = resolveUrl(import.meta.env.VITE_WS_URL, DEV_WS_URL, PROD_WS_URL);
